import { jsx as a } from "react/jsx-runtime";
import { RocheUIIcon as t } from "../icon/roche-icon.js";
import r from "./roche-avatar.module.scss.js";
const l = ({ children: e }) => /* @__PURE__ */ a("div", { className: r.avatar, children: e ?? /* @__PURE__ */ a("div", { className: r.avatar__fallback, children: /* @__PURE__ */ a("div", { className: r.avatar__icon, children: /* @__PURE__ */ a(t, { icon: "default-avatar", height: "100%", decorative: !0 }) }) }) });
export {
  l as RocheUIAvatar
};
